export default {
  language_picker_helper: "Choose a language",
  languages: {
    english: "English",
    swedish: "Swedish"
  },
  chooseQuantities: "Choose Quantities",
};
